import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

export default function NotFound() {
  return (
    <div className="flex min-h-full flex-col lg:relative ">
      <Navbar/>
      <div className="h-[100vh] bg-[url(/assets/starry.jpg)] bg-cover bg-bottom min-h-[600px]">
        <main className="flex grow flex-col h-full">
          <div className="mx-auto inline-flex w-full h-full max-w-7xl grow flex-row px-4 sm:px-6 lg:px-8">
            <div className="inline-flex w-full h-full flex-col items-center justify-center">
              <div className="flex my-auto py-16 sm:py-32 justify-center flex-col items-center">
                <p className="w-min text-[15rem] font-semibold text-gray-200 inline-block leading-none">404</p>
                <h1 className="mt-2 text-2xl font-bold tracking-tight text-gray-200 sm:text-3xl">
                  Page not found
                </h1>
                <p className="mt-2 text-base text-gray-400">
                  Sorry, we couldn’t find the page you’re looking for.
                </p>
                <div className="mt-6">
                  <a
                    href="/"
                    className="text-base font-medium text-primary hover:text-primary"
                  >
                    Go back home
                    <span aria-hidden="true"> &rarr;</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Footer/>
    </div>
  );
}

export function NotFoundBody() {
  return (
    <div className="flex min-h-full flex-col bg-background lg:relative ">
      <div className="h-[100vh] bg-[url(/assets/starry.jpg)] bg-cover bg-bottom min-h-[600px]">
        <main className="flex grow flex-col h-full">
          <div className="mx-auto inline-flex w-full h-full max-w-7xl grow flex-row px-4 sm:px-6 lg:px-8">
            <div className="inline-flex w-full h-full flex-col items-center justify-center">
              <div className="flex my-auto py-16 sm:py-32 justify-center flex-col items-center">
                <p className="w-min text-[15rem] font-semibold text-gray-200 inline-block leading-none">404</p>
                <h1 className="mt-2 text-2xl font-bold tracking-tight text-gray-200 sm:text-3xl">
                  Page not found
                </h1>
                <p className="mt-2 text-base text-gray-400">
                  Sorry, we couldn’t find the page you’re looking for.
                </p>
                <div className="mt-6">
                  <a
                    href="/"
                    className="text-base font-medium text-primary hover:text-primary"
                  >
                    Go back home
                    <span aria-hidden="true"> &rarr;</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
